module.exports = __webpack_public_path__ + "static/media/fondo_de.03a093ef.png";